<template>
  <div class="d-timetal__container">
    <h4 class="uppercase marg-1-bottom">Personale</h4>
    <div class="d-attention" v-if="personaleUdenKorrekteOplysninger.length > 0">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-important"><path class="primary" d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"/><path class="secondary" d="M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"/></svg>
      <h3>Følgende personer mangler enten CPR-nummer eller Stilling.</h3>
      <p>Gå til step 1. Undervisningskompetencer for at tilføje. Sæt til "Ikke indberet", hvis personen ikke skal indberettes.</p>
      <table class="d-table d-table__borders">
        <thead>
        <th></th>
        <th>CPR</th>
        <th>STILLING</th>
        </thead>
        <tbody>
        <tr v-for="(user, key) in personaleUdenKorrekteOplysninger" :key="user.user_id">
          <td>{{ user.name }}</td>
          <td>{{ user.cpr }}</td>
          <td>{{ user.stilling }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <table class="d-table">
      <thead>
      <th>Stilling</th>
      <th>Antal ansatte indberretes</th>
      <th>Heraf ansatte, der ikke er
        registeret undervisningskompetencer for
      </th>
      </thead>
      <tbody>
      <tr v-for="(group, key) in groupedLaerereProps" :key="key">
        <td>{{ key }}</td>
        <td v-for="prop in group">
          {{ prop.length }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    stilData: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      stillinger: {
        LA: 'Lærere',
        BH: 'Børnehaveklasseledere',
        PA: 'Pædagoger',
        LE: 'Ledere',
        AN: 'Andre med undervisningsopgaver',
        KO: 'Konsulenter'
      }
    }
  },
  computed: {
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    laerere () {
      return this.stilData['laerere'] ? this.stilData['laerere'] : []
    },
    personaleUdenKorrekteOplysninger () {
      const users = this.laerere.filter(laerer => laerer.stilling !== 'undtaget' && (!laerer.cpr || !laerer.stilling))
      const usersWithProps = users.map(user => {
        const name = this.allUsersInHash[user.user_id] ? this.allUsersInHash[user.user_id].name : user.user_id
        return {
          ...user,
          name
        }
      })
      return this.$helpers.sortArrOnName(usersWithProps)
    },
    groupedLaerere () {
      let result = {}
      for (let stilling in this.stillinger) {
        let jobTitle = this.stillinger[stilling]
        const learereWithJobTitle = this.laerere.filter(lærer => lærer.stilling === stilling)
        result[jobTitle] = learereWithJobTitle
      }
      return result
    },
    groupedLaerereProps () {
      let result = {}
      for (let jobTitle in this.groupedLaerere) {
        const laerere = this.groupedLaerere[jobTitle]
        const laerereWithFag = laerere.filter(laerer => laerer.fag.length > 0)
        const laerereWithoutFag = laerere.filter(laerer => laerer.fag.length === 0)
        result[jobTitle] = [laerereWithFag, laerereWithoutFag]
      }
      return result
    }
  }
}
</script>

<style scoped>
.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table.d-table__subjects tbody tr.tr--one {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
}

.d-table tbody tr.tr__header {
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: #728195;
}

.d-table tbody tr:not(.tr__header):hover {
  background: aliceblue !important;
}

.d-table thead {
  border: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
  color: #222;
}

.d-table tbody tr {
  background: #ffffff;
  width: 100%;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr td:first-child {
  padding-left: 2rem;
}

.d-table tbody tr.tr__header td:first-child {
  padding-left: 2rem;
}

.d-table tbody tr:nth-child(even) {
  background: #fbfbfb;
}

.d-table tbody tr td {
  padding: 0.25rem 1rem;
  text-align: left;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.d-table.d-table__borders {
  width: auto;
}

.d-table.d-table__borders tbody tr td,
.d-table.d-table__borders thead tr th {
  border-left: 1px solid #cccccc;
}

</style>



// WEBPACK FOOTER //
// IndberetPersonale.vue?70d19067